// extracted by mini-css-extract-plugin
module.exports = {"pdf-display":"pdf-display_pdf-display__fLiGK"};